module.exports = __webpack_public_path__ + "img/38606-056.b4d8bd00.jpg";